import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("rect", {
  width: "1.51397",
  height: "21.8206",
  rx: "0.756984",
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 4.82031 3.75)"
}), React.createElement("rect", {
  x: "4.82031",
  y: "20.25",
  width: "1.51397",
  height: "21.8206",
  rx: "0.756984",
  transform: "rotate(-135 4.82031 20.25)"
})), "IconClose");